<template>
  <collapse-card :loading="loading" open>
    <div slot="link">
      <div class="edit-link" @click.stop="updateSteps()">Сохранить</div>
    </div>
    <div slot="title">Физическая активность</div>

    <div class="block-title">Шаги</div>
    <el-input
        v-model="conclusion.physical_activity.recommended_number_steps.value"
        class="portions append">
      <div slot="suffix">шагов рекомендовано</div>
    </el-input>

    <exercises :activities-data="conclusion.physical_activity" @update="updateSteps"/>

    <complex-exercises/>

  </collapse-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex"

import CollapseCard from "@/components/elements/BigCard.vue"
import ComplexExercises from "@/components/visit/complexExercises/ComplexExercises"
import Exercises from "@/components/visit/complexExercises/Exercises"

export default {
  name: "Activities",
  components: {
    CollapseCard,
    ComplexExercises,
    Exercises,
  },
  data() {
    return {
      loading: false,
      checked: [],
      editableSteps: false
    }
  },
  computed: {
    ...mapGetters("visit", {
      device: "getDevices",
      conclusion: "conclusion"
    }),
    visit() {
      return this.$route.params.visit;
    },
  },
  destroyed() {

    this.setActiveTab('devices')
    this.clearConclusion()

  },
  methods: {
    ...mapActions({
      setActiveTab: "visit/SET_ACTIVE_TAB",
      clearConclusion: "visit/CLEAR_CONCLUSION",
      updateConclusion: "visit/UPDATE_CONCLUSION",
    }),
    updateSteps() {

      this.loading = true
      this.updateConclusion(this.conclusion).then(() => {
        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка 😕",
          message: response.response.data.message
        })
      }).finally(() => {
        this.loading = false
      })

    },
    setEditableSteps() {
      this.editableSteps = !this.editableSteps
    }

  }
}

</script>
<style lang="scss" scoped>
.subtitle {
  margin-top: 12px;

  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  color: #111;
}

.append /deep/ {
  .el-input__suffix {
    top: 10px;
  }

  .el-input__suffix-inner div {
    padding-right: 8px;
  }
}

.block-title {
  margin-top: 16px;

  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #111;
}

.portions {
  margin-top: 16px;
  width: 100%;
}

.edit-link {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  line-height: 26px;

  color: #43D3B3;

  &:hover {
    opacity: .5;
  }
}
</style>